import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCaretLeft20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconCaretLeft20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M13.837 16.777a.75.75 0 0 1-1.061 0L6.53 10.53 6 10l.53-.53 6.246-6.246a.75.75 0 0 1 1.06 1.06L8.121 10l5.715 5.715a.75.75 0 0 1 0 1.06"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconCaretLeft20);
